// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import onlineCourseContentsSelector from '../../redux/selectors/onlineCourseContentsSelector';
import { actionCreatorsList } from '../../redux/rootActionCreator';
import { useCurrentModule, useVodId } from '../../components/CourseContent/hooks';
import { Chapter, Note, OnlineCourse, Progress } from '../../types/Model';
import onlineCourseInformationSelector from '../../redux/selectors/onlineCourseInformationSelector';

export function useCreateNote(id: number): (vodId: number, time: number, message: string) => void {
  const dispatch = useDispatch();

  return useCallback((vodId: number, time: number, message: string) => {
    dispatch(actionCreatorsList.createOnlineCourseNoteActions.request({ id, vodId, time, message }))
  }, [id])
}

export function useUpdateNote(id: number): (noteId: string, message: string) => void {
  const dispatch = useDispatch();

  return useCallback((noteId: string, message: string) => {
    dispatch(actionCreatorsList.updateOnlineCourseNoteActions.request({ id, noteId, message }));
  }, [id])
}

export function useDeleteNote(id: number): (noteId: string) => void {
  const dispatch = useDispatch();

  return useCallback((noteId: string) => {
    dispatch(actionCreatorsList.deleteOnlineCourseNoteActions.request({ id, noteId }));
  }, [id])
}

export function useFetchNotes(id: number): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(actionCreatorsList.getOnlineCourseNotesDataActions.request({ id }))
  }, [id])
}

export function useFetchOnlineCourseInformation(id: number): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(actionCreatorsList.getOnlineCourseDataActions.request({ id }));
  }, [id])
}

export const useOnlineCourseInformation = (id: number): OnlineCourse => {
  return useSelector(onlineCourseInformationSelector.makeOnlineCourseByIdSelector(id))
}

export function useFetchOnlineCourseContents(id: number, preventLoading?: boolean): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(actionCreatorsList.getOnlineCourseContentsDataActions.request({ id, preventLoading }));
  }, [id])
}

export function useUpdateProgress(id: number): (progress: Progress) => void {
  const dispatch = useDispatch();
  const refetchContents = useFetchOnlineCourseContents(id, true);

  return useCallback((progress: Progress) => {
    dispatch(actionCreatorsList.updateOnlineCourseProgressActions.request({
      id,
      progress,
      onSuccess: () => refetchContents()
    }))
  }, [id])
}

export function useIsNoteFetching(): boolean {
  return useSelector(onlineCourseContentsSelector.makeIsFetchingOnlineCourseNotesData());
}

export function useNoteError(): Error | undefined {
  return useSelector(onlineCourseContentsSelector.makeNoteErrorOnlineCourseNotesData());
}

export function useNotes(id: number, chapters: Chapter[]): Note[] {
  const currentModule = useCurrentModule(chapters)
  const vodId = useVodId(currentModule);
  const notes = useSelector(onlineCourseContentsSelector.makeOnlineCourseNotesDataByIdSelector(id, vodId));
  return notes;
}

export function useProgress(id: number): Progress[] {
  return useSelector(onlineCourseContentsSelector.makeOnlineCourseProgressDataByIdSelector(id));
}

export function useHasCourse(id: number): boolean {
  return useSelector(onlineCourseInformationSelector.makeOnlineCourseHasCourseByIdSelector(id));
}

export function useHasSample(id: number): boolean {
  return useSelector(onlineCourseInformationSelector.makeOnlineCourseHasSampleByIdSelector(id));
}
